
export {stringify as stringifyQueryString, parse as parseQueryString} from 'query-string'

export {createRoot} from 'react-dom/client'

export {
  Redirect,
  HashRouter,
  NavLink,
  Link,
  Switch,
  Route,
  useParams,
  useHistory,
  matchPath,
  generatePath,
  useLocation
} from 'react-router-dom'

export {
  default as React,
  useMemo,
  useCallback,
  createContext,
  useReducer,
  createElement,
  createRef,
  forwardRef,
  useContext,
  useRef,
  useLayoutEffect,
  useEffect,
  Fragment,
  useState
} from 'react'


export {connect, Provider as ReduxProvider} from 'react-redux'

export {createStore, applyMiddleware, compose, combineReducers} from 'redux'

export {default as thunk} from 'redux-thunk'

import {RefAttributes, MutableRefObject, FC, PropsWithChildren, useEffect, useRef, createElement, forwardRef, useMemo, ComponentProps} from 'react'

export type {MutableRefObject}
export type {ComponentProps}

import {LinkProps} from 'react-router-dom'

export type {RefAttributes}
export type {LinkProps}
export type {PropsWithChildren}
export type {FC}

import { registerLocale} from 'react-datepicker'
import {locales} from './date-fns'

Object.entries(locales).forEach(([key, locale]) => {
  registerLocale(key, locale)
})

import "react-datepicker/dist/react-datepicker.css"

export {default as DatePicker} from 'react-datepicker'
export {registerLocale as registerDatePickerLocale} from 'react-datepicker'
export const CustomDateInput = forwardRef((props: any, _ref: unknown) => createElement('div', {className: 'date-input', onClick: props.onClick}, props.value))

import 'react-confirm-alert/src/react-confirm-alert.css'
export {confirmAlert} from 'react-confirm-alert'

export function autoSet(value:any, ...keys:string[]){
  return autoCommand({$set: value}, ...keys)
}

export function autoCommand(command:any, ...keys:string[]){
  return keys.reduceRight((obj, key) => ({$auto: {[key]: obj}}), command)
}

export function useScrollToRefChange(scrollOptions:ScrollIntoViewOptions = {behavior: 'smooth'}) {
    const ref = useRef<HTMLDivElement>(null)
    const scrollToRef = useMemo(() => {
      return () => ref.current?.scrollIntoView(scrollOptions);
    }, [scrollOptions, ref.current])
    return [ref, scrollToRef]
}

export {default as Select} from 'react-select'
export type {SingleValue} from 'react-select'